<div class="timeline-wrapper" #timelineContainer>
  <div *ngIf="isLoading" >
    <div class="timeline-loading">
    </div>
    <div class="timeline-spinner">
      <itb-spinner [spinnerType]="'s'"></itb-spinner>
    </div>
  </div>
  <div>
    <div class="timeline-content-wrapper" #timeline >
      <div class="timeline-content" [ngStyle]="getLeft()" #timelinecontent [ngStyle]="getTransitionValue()">
        <div class="node" *ngFor="let node of nodes; let i = index" [ngStyle]="getNodeDistance()">
          <div class="texts">
            <p class="title">{{node.title}}</p>
            <p class="subtitle">{{node.subtitle}}</p>
            <p class="date">{{node.date}}</p>
          </div>
          <div class="selector-container" (click)="nodeClicked(i, node)" [matTooltip]='node.tooltipText'>
            <div class="selector" [ngClass]="{'selected': i==currentSelectedNodeIndex, 'unselected' : i!=currentSelectedNodeIndex, 'filled-selector': i<=currentSelectedNodeIndex, 'unfilled-selector' : i>currentSelectedNodeIndex || i>selectableNodes}" *ngIf="!node.className || node.className==''">
              <span></span>
            </div>
            <div class="selector" class='selector {{node.className}}' *ngIf="node.className && node.className!=''">
              <span></span>
            </div>
          </div>
          <div class="line" [ngStyle]="getNodeDistance()" [ngClass]="{'filled': i<selectableNodes-1 && i<currentSelectedNodeIndex, 'unfilled' : i>=selectableNodes || i>=currentSelectedNodeIndex}">
          </div>
          <div class="texts">
            <p class="status">{{node.status}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="prev-button">
      <div (click)="previous()" [ngClass]="previousButtonClass"></div>
    </div>
    <div class="next-button">
      <div (click)="next()" [ngClass]="nextButtonClass"></div>
    </div>
  </div>
</div>